import { Component, h, Element, Host } from '@stencil/core';

const BREADCRUMBS_BODY_CLASS = 'adl-breadcrumbs--visible';

@Component({
  tag: 'aafp-breadcrumb',
  shadow: false,
})
export class AafpBreadcrumb {
  @Element() element: any;

  render() {
    return (
      <Host class="adl-breadcrumb">
        <nav class="adl-breadcrumb__nav" aria-label="Breadcrumb">
          <ol class="adl-breadcrumb__list">
            <slot name="breadcrumb-links"></slot>
          </ol>
        </nav>
      </Host>
    );
  }

  componentWillRender() {
    const breadcrumbs: NodeListOf<HTMLLIElement> = this.element.querySelectorAll('li[slot="breadcrumb-links"]');

    this.addBreadcrumbVisibleClass(breadcrumbs.length, document.body);
  }

  addBreadcrumbVisibleClass(numberOfBreadcrumbs: number, bodyRef: HTMLElement) {
    const isVisible = numberOfBreadcrumbs > 1;

    bodyRef.classList[isVisible ? 'add' : 'remove'](BREADCRUMBS_BODY_CLASS);
    this.element.classList[isVisible ? 'remove' : 'add']('adl-hide');
  }
}
